var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFt06(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1803_278",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 62.5V1.49999H1.5V62.5H62.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1803_278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.07363 10.9797C6.58525 11.4875 4.1835 12.3009 1.875 13.443V59.0629C12.8903 55.5086 22.6525 56.5291 32 59.0629",
    stroke: "url(#paint0_linear_1803_278)",
    strokeWidth: 3,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9238 10.9792C57.413 11.487 59.8158 12.3005 62.125 13.443V59.0628C51.1098 55.5087 41.3476 56.5291 32 59.0628",
    stroke: "url(#paint1_linear_1803_278)",
    strokeWidth: 3,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 5.91076C16.2495 3.44176 29.5 5.56801 32 13.443V57.8129C27.0651 52.8779 18.2689 47.7908 9.375 50.2805V5.91076Z",
    stroke: "url(#paint2_linear_1803_278)",
    strokeWidth: 3,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.625 5.91076C47.7504 3.44176 34.5 5.56801 32 13.443V57.8129C36.9349 52.8779 45.731 47.7908 54.625 50.2805V5.91076Z",
    stroke: "url(#paint3_linear_1803_278)",
    strokeWidth: 3,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1803_278",
    x1: 16.9375,
    y1: 59.0629,
    x2: 16.9375,
    y2: 10.9797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDA6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1803_278",
    x1: 47.0625,
    y1: 59.0628,
    x2: 47.0625,
    y2: 10.9792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDA6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1803_278",
    x1: 20.6875,
    y1: 57.8129,
    x2: 20.6875,
    y2: 4.93713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDA6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1803_278",
    x1: 43.3125,
    y1: 57.8129,
    x2: 43.3125,
    y2: 4.93713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDA6FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFt06);
export default __webpack_public_path__ + "static/media/ft_06.16792693218c2d72fa971f11450dc15f.svg";
export { ForwardRef as ReactComponent };